module.exports = __webpack_public_path__ + "static/media/Solar.2ced7809.logo";